import React from 'react';
import './CAFCTextSection.css';

const CAFCTextSection = ({ cmsData }) => {
  return (
    <div className="cafc-text-section">
      <div className="legal-disclosure">
        <div className="disclosure-header">
          <h3>{cmsData?.title}</h3>
          <h3>{cmsData?.subTitle}</h3>
        </div>
        
        <div className="disclosure-content">
          <div dangerouslySetInnerHTML={{ __html: cmsData?.description || '' }} />
        </div>
      </div>
    </div>
  );
};

export default CAFCTextSection;